///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.users = abcsetup.users || {};
abcsetup.users.notification = abcsetup.users.notification || {};
abcsetup.users.notification.index = abcsetup.users.notification.index || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.users.notification.index = {
    init: function() {
        abcsetup.setTitle('Notifications');
    },
}
